export const USER_CHECKS_USER_IP_ADDRESS_CHECK_REQUEST = '[USER_CHECKS]_USER_IP_ADDRESS_CHECK_REQUEST'
export const USER_CHECKS_USER_IP_ADDRESS_CHECK_RESPONSE = '[USER_CHECKS]_USER_IP_ADDRESS_CHECK_RESPONSE'
export const USER_CHECKS_USER_IP_ADDRESS_CHECK_FAILURE = '[USER_CHECKS]_USER_IP_ADDRESS_CHECK_FAILURE'

export const USER_CHECKS_RESPONSE_MESSAGE_RESET = '[USER_CHECKS]_RESPONSE_MESSAGE_RESET'
